export default __webpack_public_path__ + "static/media/about2.148f9327.jpg";